/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener("click", function(e) {
  if (e.target.matches(".btn-add")) {
    e.preventDefault();
    e.stopPropagation();
    fetch('/cart.js').then((response) => response.json())
      .then((data) => {
      if(data['item_count'] == 1){
        alert('You are only allowed to apply for one item at a time. Please remove an item from the cart');
      }else{
        let el = e.target;
        el.innerText = "Adding...";
    
        let xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/update.js", true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 400) { // success
            location.href = "/pages/form";
          } else { // we reached our target server, but it returned an error
            alert("Unexpected server error. Please try again");
            el.innerText = "Add to cart";
          }
        };
        xhr.onerror = function () { // There was a connection error of some sort
          alert("Unexpected connection error. Please try again later");
          el.innerText = "Add to cart";
        };
        xhr.send("updates[" + el.dataset.variant + "]=1");
      } 
    });
  }

  if (e.target.matches(".remove-item-from-cart")) {
    e.preventDefault();
    e.stopPropagation();
    let el = e.target;
    el.innerText = "Removing...";
    addClass(el, "processing");
    let xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/update.js", true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 400) { // success
        // let resp = JSON.parse(xhr.responseText);
        location.reload();
      } else { // we reached our target server, but it returned an error
        alert("Unexpected server error. Please try again");
      }
    };
    xhr.onerror = function() { // There was a connection error of some sort
      alert("Unexpected connection error. Please try again");
    };
    xhr.send("updates[" + el.dataset.variantId + "]=0");
  }
}, false);

function addClass(el, className) {
  if (el.classList)
    el.classList.add(className);
  else
    el.className += ' ' + className;
}